export default __webpack_public_path__ + "static/media/file-alt-regular.29afd2bb.svg";